import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `document/all?dossierId=${dossierId}`, method: 'GET', token: token })
}
